export const uploadVideoToVimeo = async (
  title: string,
  description: string,
  videoFile: File,
  accessToken: string
): Promise<string> => {
  try {
    // Step 1: Create a video on Vimeo and get an upload link
    const createVideoResponse = await fetch('https://api.vimeo.com/me/videos', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        upload: {
          approach: 'tus',
          size: videoFile.size,
        },
        name: title,
        description,
      }),
    });

    if (!createVideoResponse.ok) {
      const errorData = await createVideoResponse.json();
      throw new Error(`Failed to create video: ${errorData.error}`);
    }

    const videoData = await createVideoResponse.json();
    const uploadLink = videoData.upload.upload_link;

    // Step 2: Upload the video using the TUS protocol
    const uploadResponse = await fetch(uploadLink, {
      method: 'PATCH',
      headers: {
        'Tus-Resumable': '1.0.0',
        'Upload-Offset': '0',
        'Content-Type': 'application/offset+octet-stream',
      },
      body: videoFile,
    });

    if (!uploadResponse.ok) {
      const errorData = await uploadResponse.json();
      throw new Error(`Failed to upload video: ${errorData.error}`);
    }

    console.log(`Video uploaded successfully: ${videoData.link}`);

    // Step 3: Return the Vimeo video ID
    const vimeoId = videoData.uri.split('/').pop();
    return vimeoId;
  } catch (error: any) {
    console.error('Video upload failed:', error.message);
    throw new Error(`Video upload failed: ${error.message}`);
  }
};
